'use client';

import {
  TireEfficiencyFlag,
  type TireEfficiencyFlagProps,
} from '@packages/shared/src/ui/TireEfficiencyFlag/TireEfficiencyFlag';
import { useIntl } from 'react-intl';
import { tireEfficiencyFlagMessages } from '../../messages';

export type TireEfficiencyFlagLocalizedProps = Omit<TireEfficiencyFlagProps, 'aria-label'>;

export const TireEfficiencyFlagLocalized = ({
  className,
  ...flagProps
}: TireEfficiencyFlagLocalizedProps) => {
  const { formatMessage } = useIntl();
  return (
    <TireEfficiencyFlag
      {...flagProps}
      className={className}
      aria-label={formatMessage(tireEfficiencyFlagMessages[flagProps.type])}
    />
  );
};
